module.exports = __webpack_public_path__ + "static/media/java.ad3638df.png";